import { ActivityLogEvent } from '@/constants/activityLogEvent';

export const APPOINTMENT_ACTION_FILTERS = [
  ActivityLogEvent.appointment_canceled,
  ActivityLogEvent.appointment_confirmed,
  ActivityLogEvent.appointment_scheduled,
  ActivityLogEvent.appointment_status,
  ActivityLogEvent.APPOINTMENT_CANCELED_EVENT,
  ActivityLogEvent.APPOINTMENT_CONFIRMED_EVENT,
  ActivityLogEvent.APPOINTMENT_SCHEDULED_EVENT,
  ActivityLogEvent.APPOINTMENT_STATUS_EVENT
];

export const ACHIEVEMENT_ACTION_FILTERS = [ActivityLogEvent.person_achievement_created];

export const APP_OPEN_ACTION_FILTERS = [ActivityLogEvent.APP_OPEN_EVENT, ActivityLogEvent.app_open];

export const APP_UNINSTALL_ACTION_FILTERS = [
  ActivityLogEvent.uninstall_detected,
  ActivityLogEvent.UNINSTALL_DETECTED_EVENT
];

export const CHALLENGE_ACTION_FILTERS = [
  ActivityLogEvent.CHALLENGE_FINISHED_EVENT,
  ActivityLogEvent.challenge_finished
];

export const DRUG_SCREEN_ACTION_FILTERS = [
  ActivityLogEvent.drug_screen_occured,
  ActivityLogEvent.DRUG_SCREEN_OCCURRED_EVENT
];

export const ENGAGEMENT_ACTIVITY_ACTION_FILTERS = [ActivityLogEvent.engaged];

export const EPISODE_OF_CARE_ACTION_FILTERS = [
  ActivityLogEvent.episode_of_care_admitted,
  ActivityLogEvent.episode_of_care_discharged,
  ActivityLogEvent.EPISODE_OF_CARE_ADMITTED,
  ActivityLogEvent.EPISODE_OF_CARE_DISCHARGED
];

export const LOG_IN_ACTION_FILTERS = [
  ActivityLogEvent.login,
  ActivityLogEvent.log_in,
  ActivityLogEvent.LOG_IN_EVENT
];

export const LOG_OUT_ACTION_FILTERS = [ActivityLogEvent.log_out, ActivityLogEvent.LOG_OUT];

export const MESSAGE_ACTION_FILTERS = [
  ActivityLogEvent.INBOUND_MESSAGE_CREATED_EVENT,
  ActivityLogEvent.inbound_message_created,
  ActivityLogEvent.OUTBOUND_MESSAGE_CREATED_EVENT,
  ActivityLogEvent.outbound_message_created
];

export const MISSION_ACTION_FILTERS = [
  ActivityLogEvent.MISSION_FINISHED_EVENT,
  ActivityLogEvent.mission_finished
];

export const NOTE_ACTION_FILTERS = [ActivityLogEvent.kustomer_note_created];

export const PERSON_MERGE_ACTION_FILTERS = [ActivityLogEvent.person_merge];

export const PHASE_ACTION_FILTERS = [
  ActivityLogEvent.PHASE_TRANSITION_EVENT,
  ActivityLogEvent.phase_transition
];

export const PROGRAM_QUALIFICATION_ACTION_FILTERS = [
  ActivityLogEvent.PROGRAM_QUALIFICATION_EVENT,
  ActivityLogEvent.PROGRAM_QUALIFICATION_DISQUALIFIED_EVENT,
  ActivityLogEvent.PROGRAM_QUALIFICATION_INTAKE_REJECTED_EVENT,
  ActivityLogEvent.program_qualification,
  ActivityLogEvent.program_qualification_disqualified,
  ActivityLogEvent.program_qualification_intake_rejected
];

export const REFERRAL_ACTION_FILTERS = [
  ActivityLogEvent.referral_created,
  ActivityLogEvent.REFERRAL_CREATED_EVENT
];

export const SIGN_UP_ACTION_FILTERS = [
  ActivityLogEvent.sign_up,
  ActivityLogEvent.sign_up_complete,
  ActivityLogEvent.SIGN_UP_COMPLETE_EVENT,
  ActivityLogEvent.SIGN_UP_EVENT
];

export const SURVEY_ACTION_FILTERS = [
  ActivityLogEvent.SURVEY_SUBMITTED_EVENT,
  ActivityLogEvent.survey_submitted,
  ActivityLogEvent.SURVEY_PARTIAL_COMPLETION_EVENT,
  ActivityLogEvent.survey_partial_completion
];

export const TASK_ACTION_FILTERS = [ActivityLogEvent.work_item_created];

export default {};
